export default __webpack_public_path__ + "static/media/logo.374d58a5.jpg";